import { Component } from "react"
import Top from "./Top"
import Bottom from "./Bottom"
import Serve from "./Serve"
import "./index.css"
import "./Serve.css"
import "./PageLayout.css"

class StudentsPage extends Component {
  componentDidMount() {
    document.documentElement.scrollTop = document.body.scrollTop = 0
  }

  render() {
    return (
      <div>
        <Top />
        <div className="page-container">
          <div className="page-header">
            <h1 className="page-title">学生培养</h1>
            <p className="page-subtitle">展示学生在嵌入式系统设计课程中的学习成果和能力培养情况</p>
          </div>
          <Serve />
        </div>
        <Bottom />
      </div>
    )
  }
}

export default StudentsPage